import { useSelector } from 'react-redux';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  HeaderWaffleMenuItems,
  HeaderWaffleMenuTitle
} from '@cat-ecom/pcc-components';
import {
  CVRPromoteEnrollCountryCodes,
  CVRPromoteEnrollLocales,
  USER_TYPE_GUEST
} from '@app/constants/commonConstants';
import { useCVRLabels } from '@app/components/pages/account/hooks';

const WaffleDrawer = drawerProps => {
  const mobileLabel = useSelector(s => s.header?.waffle?.mobileLabel) ?? '';
  const menuItems = useSelector(s => s.header?.waffle?.menuItems);
  const locale = useSelector(s => s.common.locale);
  const isCVRPromoteEnrollEnabled = useSelector(
    s => s.featureFlag.PCC_CVRPromoteEnrollment
  );
  const isGuest = useSelector(s => s.common.userType) === USER_TYPE_GUEST;
  const countryCode = window?.catReact?.akamaiHeaderCountryCode;

  const { catVantageRewardCopyright } = useCVRLabels();

  const showCVREnrollment =
    isCVRPromoteEnrollEnabled &&
    CVRPromoteEnrollCountryCodes.includes(countryCode) &&
    isGuest;

  const items = menuItems?.map(item => ({
    label: item?.appLabel,
    link: item?.appUrl
  }));

  if (showCVREnrollment) {
    items.push({
      label: catVantageRewardCopyright,
      link: CVRPromoteEnrollLocales.includes(locale)
        ? `/${locale.slice(0, 2)}/catcorp/getrewarded`
        : '/en/catcorp/getrewarded'
    });
  }

  return (
    <Drawer {...drawerProps}>
      <DrawerHeader>
        <HeaderWaffleMenuTitle title={mobileLabel.toLowerCase()} />
      </DrawerHeader>
      <DrawerBody>
        <HeaderWaffleMenuItems items={items} />
      </DrawerBody>
    </Drawer>
  );
};

export default WaffleDrawer;
